import { useState } from "react";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";

const GroupStudentsDropdown = ({ data }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const activeStudents = data.students?.filter((item) => {
    const targetGroupItem = item.groups?.find(
      (groupItem) => groupItem.group === data._id
    );

    // console.log(targetGroupItem?.status, "target group item");

    return (
      !item?.deleted &&
      ["waiting", "graduate", "continue", "debtor-graduate"].includes(
        targetGroupItem?.status
      )
    );
  });

  return (
    <div
      className={`global-category-dropdown dropdown-name data-status  ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>Bütün Tələbələr ({activeStudents?.length})</h2>
        <div className="arrow-icon" style={{ marginLeft: "10px" }}>
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {activeStudents?.map((student) => (
            <li key={student._id}>{student.fullName}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GroupStudentsDropdown;
